import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import RichContent from 'components/RichContent/RichContent';

import { StructuredText } from '.';

interface RichTextBlockRecord extends CdaStructuredTextRecord {
  content: StructuredText;
  align?: 'default' | 'left' | 'center' | 'right';
}

export default function RichTextBlock({ content, align }: RichTextBlockRecord) {
  return <RichContent align={align !== 'default' ? align : undefined}>{content}</RichContent>;
}
